/* ============================================================================
   ISHA COLLECTIONS - HEADER JS (DYNAMIC STICKY & FILTER SYNC)
============================================================================ */

document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Mobile Menu Toggle Logic
  const mobileToggle = document.getElementById('isha-mobile-toggle');
  const navMenu = document.getElementById('isha-nav-menu');

  if (mobileToggle && navMenu) {
    mobileToggle.addEventListener('click', function() {
      navMenu.classList.toggle('is-open');
    });
    // Close menu if clicking outside of it
    document.addEventListener('click', function(event) {
      if (!navMenu.contains(event.target) && !mobileToggle.contains(event.target)) {
        navMenu.classList.remove('is-open');
      }
    });
  }

  // 2. Cart Icon Logic
  const cartTrigger = document.getElementById('isha-cart-trigger');
  const dawnCartDrawer = document.querySelector('cart-drawer');

  if (cartTrigger && dawnCartDrawer) {
    cartTrigger.addEventListener('click', function(e) {
      e.preventDefault(); 
      dawnCartDrawer.open(); 
    });
  }

  // 3. SMART SCROLL LOGIC (Header & Filter Bar Sync)
  let lastScroll = 0;
  
  const headerWrapper = document.querySelector('.isha-header-wrapper');
  const headerSection = headerWrapper ? headerWrapper.parentElement : null;
  const filterBar = document.querySelector('.isha-filter-bar-container');

  // Ensure header has sticky properties
  if (headerSection) {
    headerSection.style.position = 'sticky';
    headerSection.style.top = '0';
    headerSection.style.zIndex = '999';
    headerSection.style.transition = 'transform 0.3s ease-in-out';
  }

  // Ensure filter bar has smooth transitions if it exists
  if (filterBar) {
    filterBar.style.transition = 'top 0.3s ease-in-out';
    filterBar.style.zIndex = '998'; // Keep it just below the header
  }

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    // 1. SHRINK LOGIC: Trigger shrink effect after scrolling 50px
    if (currentScroll > 50) {
      if (headerWrapper) headerWrapper.classList.add('is-shrunk');
    } else {
      if (headerWrapper) headerWrapper.classList.remove('is-shrunk');
    }

    // Measure current header height (dynamically adjusts if it is shrunk)
    const headerHeight = headerWrapper ? headerWrapper.offsetHeight : 70;

    // 2. SCROLL DIRECTION LOGIC
    if (currentScroll > lastScroll && currentScroll > headerHeight) {
      
      // SCROLLING DOWN (Browsing)
      // Hide the header
      if (headerSection) headerSection.style.transform = 'translateY(-100%)';
      // Pin the filter bar to the absolute top of the screen
      if (filterBar) filterBar.style.top = '0px';

    } else if (currentScroll < lastScroll) {
      
      // SCROLLING UP (Navigating)
      // Show the header
      if (headerSection) headerSection.style.transform = 'translateY(0)';
      // Push the filter bar down exactly below the header
      if (filterBar) filterBar.style.top = `${headerHeight}px`;
      
    }
    
    // Save current scroll position for the next calculation
    lastScroll = currentScroll <= 0 ? 0 : currentScroll; 
  });
});